import React from 'react'
import { SearchBarTable } from 'hljd'
import columns from './columns'

export default ({ store }) => {
  return (
    <SearchBarTable
      style={{ marginTop: 20 }}
      store={store}
      columns={columns(store)}
    />
  )
}
